import { AnyAction, combineReducers } from "redux";

const base = (
  state: any = {},
  action: AnyAction
): any => {
  return state;
};


export const rootReducer = combineReducers({
  base
});
